"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _text = require("../../../styles/2_commonComponentStyles/text");

var _Divider = require("./Divider.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * This is our standard divider component, to be used in place of an hr element
 */
// intentionally left as a functional component
var Divider = function Divider(_ref) {
  var className = _ref.className,
      colorTheme = _ref.colorTheme,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, ["className", "colorTheme", "size"]);

  return /*#__PURE__*/_react.default.createElement(_Divider.StyledDivider, _extends({
    className: [className, size === 'full' ? 'c-divider-full' : ''].join(' '),
    colorTheme: colorTheme
  }, props));
};

Divider.propTypes = {
  /** Hook for overriding top-level component styles */
  className: _propTypes.PropTypes.string,

  /** What color should this be */
  colorTheme: _propTypes.PropTypes.oneOf(_text.textThemes),
  // intentionally omitting the dataTestId on this component

  /** Should this span the width of the column, or go full screen? */
  size: _propTypes.PropTypes.oneOf([undefined, 'full'])
};
Divider.defaultProps = {
  className: '',
  colorTheme: 'cta',
  size: undefined
};
var _default = Divider;
exports.default = _default;